import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { TotalRecordsAction } from ".";
import { defaultTotalRecords, defaultTotalRecordsState } from "./default";
import { FETCH_STUDENT_RECORD_LIST_FAILED, FETCH_STUDENT_RECORD_LIST_PROGRESS, FETCH_STUDENT_RECORD_LIST_SUCCESS } from "./action";


export const totalRecordReducer = (
  state: IStoreState["TotalRecords"] = defaultTotalRecordsState,
  action: TotalRecordsAction
) => {
    switch (action.type) {
        case FETCH_STUDENT_RECORD_LIST_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.totalRecordsFee.loading = LoadState.InProgress;
               draftState.record.data = [];
               draftState.totalRecordsFee.data = defaultTotalRecords;
               draftState.record.totalRecords = 0;
               
               
             });
             return newState;
           }
           case FETCH_STUDENT_RECORD_LIST_SUCCESS: {
             const { data,  singleReport, totalRecords } = action.payload;
             const newState = produce(state, (draftState) => {
               draftState.totalRecordsFee.loading = LoadState.Loaded;
               draftState.totalRecordsFee.data = singleReport;
               draftState.record.data = data;
               draftState.record.totalRecords = totalRecords;
              
             });
             return newState;
           }
           case FETCH_STUDENT_RECORD_LIST_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.totalRecordsFee.loading = LoadState.Failed;
               draftState.record.data = [];
               draftState.totalRecordsFee.data = defaultTotalRecords;
               draftState.record.totalRecords = 0;
              


             });
             return newState;
           }

           
           default: {
            return state;
          }
      }
    
};
